var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.222,
    height: 14.222,
    viewBox: "0 0 14.222 14.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-line",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M8,.889A7.111,7.111,0,1,0,15.111,8,7.111,7.111,0,0,0,8,.889ZM8,14.222A6.222,6.222,0,1,1,14.222,8,6.222,6.222,0,0,1,8,14.222Z",
    transform: "translate(-0.889 -0.889)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M8.129,3.964A3.28,3.28,0,0,0,5.587,5.106a.444.444,0,0,0-.142.316.409.409,0,0,0,.422.409A.48.48,0,0,0,6.183,5.7a2.533,2.533,0,0,1,1.924-.889,1.551,1.551,0,0,1,1.7,1.516v.022c0,.982-.782,1.529-2.018,1.622a.356.356,0,0,0-.338.409V9.6A.444.444,0,0,0,7.9,10h.049a.444.444,0,0,0,.4-.444V8.644c1.333-.187,2.413-.889,2.413-2.347V6.275A2.385,2.385,0,0,0,8.128,3.964Z",
    transform: "translate(-0.889 -0.889)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M8.458,11.644a.556.556,0,1,1-.556-.532.556.556,0,0,1,.556.532Z",
    transform: "translate(-0.889 -0.889)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0c3cf35c.svg";
export { ForwardRef as ReactComponent };